/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentBracketTypeOption } from './TournamentBracketTypeOption';
import {
    TournamentBracketTypeOptionFromJSON,
    TournamentBracketTypeOptionFromJSONTyped,
    TournamentBracketTypeOptionToJSON,
    TournamentBracketTypeOptionToJSONTyped,
} from './TournamentBracketTypeOption';
import type { TournamentCategoryOption } from './TournamentCategoryOption';
import {
    TournamentCategoryOptionFromJSON,
    TournamentCategoryOptionFromJSONTyped,
    TournamentCategoryOptionToJSON,
    TournamentCategoryOptionToJSONTyped,
} from './TournamentCategoryOption';
import type { TournamentSkillLevelOption } from './TournamentSkillLevelOption';
import {
    TournamentSkillLevelOptionFromJSON,
    TournamentSkillLevelOptionFromJSONTyped,
    TournamentSkillLevelOptionToJSON,
    TournamentSkillLevelOptionToJSONTyped,
} from './TournamentSkillLevelOption';
import type { TournamentBestOfOption } from './TournamentBestOfOption';
import {
    TournamentBestOfOptionFromJSON,
    TournamentBestOfOptionFromJSONTyped,
    TournamentBestOfOptionToJSON,
    TournamentBestOfOptionToJSONTyped,
} from './TournamentBestOfOption';
import type { TournamentTimerConfig } from './TournamentTimerConfig';
import {
    TournamentTimerConfigFromJSON,
    TournamentTimerConfigFromJSONTyped,
    TournamentTimerConfigToJSON,
    TournamentTimerConfigToJSONTyped,
} from './TournamentTimerConfig';
import type { TournamentPlatformOption } from './TournamentPlatformOption';
import {
    TournamentPlatformOptionFromJSON,
    TournamentPlatformOptionFromJSONTyped,
    TournamentPlatformOptionToJSON,
    TournamentPlatformOptionToJSONTyped,
} from './TournamentPlatformOption';
import type { TournamentLateRegistrationOption } from './TournamentLateRegistrationOption';
import {
    TournamentLateRegistrationOptionFromJSON,
    TournamentLateRegistrationOptionFromJSONTyped,
    TournamentLateRegistrationOptionToJSON,
    TournamentLateRegistrationOptionToJSONTyped,
} from './TournamentLateRegistrationOption';
import type { TournamentPrivacyOption } from './TournamentPrivacyOption';
import {
    TournamentPrivacyOptionFromJSON,
    TournamentPrivacyOptionFromJSONTyped,
    TournamentPrivacyOptionToJSON,
    TournamentPrivacyOptionToJSONTyped,
} from './TournamentPrivacyOption';
import type { TournamentTeamSizeOption } from './TournamentTeamSizeOption';
import {
    TournamentTeamSizeOptionFromJSON,
    TournamentTeamSizeOptionFromJSONTyped,
    TournamentTeamSizeOptionToJSON,
    TournamentTeamSizeOptionToJSONTyped,
} from './TournamentTeamSizeOption';
import type { TournamentRefundPolicy } from './TournamentRefundPolicy';
import {
    TournamentRefundPolicyFromJSON,
    TournamentRefundPolicyFromJSONTyped,
    TournamentRefundPolicyToJSON,
    TournamentRefundPolicyToJSONTyped,
} from './TournamentRefundPolicy';
import type { TournamentRegionOption } from './TournamentRegionOption';
import {
    TournamentRegionOptionFromJSON,
    TournamentRegionOptionFromJSONTyped,
    TournamentRegionOptionToJSON,
    TournamentRegionOptionToJSONTyped,
} from './TournamentRegionOption';

/**
 * Global tournament configuration settings (API response shape)
 * @export
 * @interface TournamentSettingsResponse
 */
export interface TournamentSettingsResponse {
    /**
     * 
     * @type {string}
     * @memberof TournamentSettingsResponse
     */
    id: string;
    /**
     * 
     * @type {Array<TournamentPlatformOption>}
     * @memberof TournamentSettingsResponse
     */
    platforms: Array<TournamentPlatformOption>;
    /**
     * 
     * @type {Array<TournamentRegionOption>}
     * @memberof TournamentSettingsResponse
     */
    regions: Array<TournamentRegionOption>;
    /**
     * 
     * @type {Array<TournamentTeamSizeOption>}
     * @memberof TournamentSettingsResponse
     */
    teamSizes: Array<TournamentTeamSizeOption>;
    /**
     * 
     * @type {Array<TournamentBracketTypeOption>}
     * @memberof TournamentSettingsResponse
     */
    bracketTypes: Array<TournamentBracketTypeOption>;
    /**
     * 
     * @type {Array<TournamentPrivacyOption>}
     * @memberof TournamentSettingsResponse
     */
    privacyOptions: Array<TournamentPrivacyOption>;
    /**
     * 
     * @type {Array<TournamentSkillLevelOption>}
     * @memberof TournamentSettingsResponse
     */
    skillLevels: Array<TournamentSkillLevelOption>;
    /**
     * 
     * @type {TournamentTimerConfig}
     * @memberof TournamentSettingsResponse
     */
    timerConfig: TournamentTimerConfig;
    /**
     * 
     * @type {TournamentRefundPolicy}
     * @memberof TournamentSettingsResponse
     */
    refundPolicy: TournamentRefundPolicy;
    /**
     * 
     * @type {Array<TournamentLateRegistrationOption>}
     * @memberof TournamentSettingsResponse
     */
    lateRegistrationOptions: Array<TournamentLateRegistrationOption>;
    /**
     * 
     * @type {Array<TournamentBestOfOption>}
     * @memberof TournamentSettingsResponse
     */
    bestOfOptions: Array<TournamentBestOfOption>;
    /**
     * 
     * @type {Array<TournamentCategoryOption>}
     * @memberof TournamentSettingsResponse
     */
    categoryOptions: Array<TournamentCategoryOption>;
    /**
     * 
     * @type {string}
     * @memberof TournamentSettingsResponse
     */
    lastModifiedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentSettingsResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentSettingsResponse
     */
    updatedAt: number;
}

/**
 * Check if a given object implements the TournamentSettingsResponse interface.
 */
export function instanceOfTournamentSettingsResponse(value: object): value is TournamentSettingsResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('platforms' in value) || value['platforms'] === undefined) return false;
    if (!('regions' in value) || value['regions'] === undefined) return false;
    if (!('teamSizes' in value) || value['teamSizes'] === undefined) return false;
    if (!('bracketTypes' in value) || value['bracketTypes'] === undefined) return false;
    if (!('privacyOptions' in value) || value['privacyOptions'] === undefined) return false;
    if (!('skillLevels' in value) || value['skillLevels'] === undefined) return false;
    if (!('timerConfig' in value) || value['timerConfig'] === undefined) return false;
    if (!('refundPolicy' in value) || value['refundPolicy'] === undefined) return false;
    if (!('lateRegistrationOptions' in value) || value['lateRegistrationOptions'] === undefined) return false;
    if (!('bestOfOptions' in value) || value['bestOfOptions'] === undefined) return false;
    if (!('categoryOptions' in value) || value['categoryOptions'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function TournamentSettingsResponseFromJSON(json: any): TournamentSettingsResponse {
    return TournamentSettingsResponseFromJSONTyped(json, false);
}

export function TournamentSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentSettingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'platforms': ((json['platforms'] as Array<any>).map(TournamentPlatformOptionFromJSON)),
        'regions': ((json['regions'] as Array<any>).map(TournamentRegionOptionFromJSON)),
        'teamSizes': ((json['teamSizes'] as Array<any>).map(TournamentTeamSizeOptionFromJSON)),
        'bracketTypes': ((json['bracketTypes'] as Array<any>).map(TournamentBracketTypeOptionFromJSON)),
        'privacyOptions': ((json['privacyOptions'] as Array<any>).map(TournamentPrivacyOptionFromJSON)),
        'skillLevels': ((json['skillLevels'] as Array<any>).map(TournamentSkillLevelOptionFromJSON)),
        'timerConfig': TournamentTimerConfigFromJSON(json['timerConfig']),
        'refundPolicy': TournamentRefundPolicyFromJSON(json['refundPolicy']),
        'lateRegistrationOptions': ((json['lateRegistrationOptions'] as Array<any>).map(TournamentLateRegistrationOptionFromJSON)),
        'bestOfOptions': ((json['bestOfOptions'] as Array<any>).map(TournamentBestOfOptionFromJSON)),
        'categoryOptions': ((json['categoryOptions'] as Array<any>).map(TournamentCategoryOptionFromJSON)),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function TournamentSettingsResponseToJSON(json: any): TournamentSettingsResponse {
    return TournamentSettingsResponseToJSONTyped(json, false);
}

export function TournamentSettingsResponseToJSONTyped(value?: TournamentSettingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'platforms': ((value['platforms'] as Array<any>).map(TournamentPlatformOptionToJSON)),
        'regions': ((value['regions'] as Array<any>).map(TournamentRegionOptionToJSON)),
        'teamSizes': ((value['teamSizes'] as Array<any>).map(TournamentTeamSizeOptionToJSON)),
        'bracketTypes': ((value['bracketTypes'] as Array<any>).map(TournamentBracketTypeOptionToJSON)),
        'privacyOptions': ((value['privacyOptions'] as Array<any>).map(TournamentPrivacyOptionToJSON)),
        'skillLevels': ((value['skillLevels'] as Array<any>).map(TournamentSkillLevelOptionToJSON)),
        'timerConfig': TournamentTimerConfigToJSON(value['timerConfig']),
        'refundPolicy': TournamentRefundPolicyToJSON(value['refundPolicy']),
        'lateRegistrationOptions': ((value['lateRegistrationOptions'] as Array<any>).map(TournamentLateRegistrationOptionToJSON)),
        'bestOfOptions': ((value['bestOfOptions'] as Array<any>).map(TournamentBestOfOptionToJSON)),
        'categoryOptions': ((value['categoryOptions'] as Array<any>).map(TournamentCategoryOptionToJSON)),
        'lastModifiedBy': value['lastModifiedBy'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

